const APP_STORE_URL = 'https://apps.apple.com/pl/app/carfree-rent-a-car/id6802304361'
const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=pl.carfree.app'

const APPLE_UA_REGEX = /iPhone|iPad|iPod|Macintosh|Mac OS X/

const isAppleUserAgent = (userAgent?: string) => !!userAgent && APPLE_UA_REGEX.test(userAgent)

interface NavigatorUAData {
	platform: string
}

const detectIsApple = () => {
	const platform = (navigator as Navigator & { userAgentData?: NavigatorUAData }).userAgentData?.platform
	return platform ? /mac|ios/i.test(platform) : isAppleUserAgent(navigator.userAgent)
}

// Detection must stay client-only: this page is served from a shared, public
// ISR/CDN cache with no `Vary: user-agent`, so anything baked in during SSR
// would be cached once and served to every visitor regardless of their device.
export const useStoreLink = () => {
	const storeLink = ref(GOOGLE_PLAY_URL)

	onMounted(() => {
		if (detectIsApple()) storeLink.value = APP_STORE_URL
	})

	return { storeLink }
}
